import { Icon } from "@blueprintjs/core"
import { Tooltip } from "@blueprintjs/core"
import classcat from "classcat"
import React from "react"

import styles from "./CopyableText.module.css"

import { showToast } from "~/containers/ToasterContainer"

type Props = {
  text: string
  className?: string
}

const CopyableText = (props: Props) => {
  const { text, className } = props

  const handleCopy = async () => {
    await navigator.clipboard.writeText(text)

    showToast({
      message: "Copied to clipboard",
      type: "success",
    })
  }

  return (
    <div className={classcat([styles.container, className])}>
      {text}{" "}
      <Tooltip content="Copy to clipboard" position="bottom">
        <Icon
          icon="clipboard"
          className={styles.copyIcon}
          size={14}
          color="var(--smoke)"
          onClick={handleCopy}
        />
      </Tooltip>
    </div>
  )
}

export default CopyableText
